import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api.js';
import { useAuth } from '../lib/auth.jsx';

const ARGUMENTS = [
  {
    titre: 'Décrivez le voyage, pas le programme',
    texte:
      'Une destination, des dates ou une simple durée, un budget, et qui vous accompagne. C’est tout ce qu’il faut pour commencer.',
  },
  {
    titre: 'Un itinéraire qui tient compte du groupe',
    texte:
      'Les âges, les allergies, la mobilité de chacun pèsent sur les suggestions — un enfant de sept ans ne suit pas le rythme d’un adulte.',
  },
  {
    titre: 'Le vôtre, au bout du compte',
    texte:
      'Modifiez, ajoutez, retirez. Emportez le programme en PDF, partagez-le d’un lien à ceux qui partent avec vous.',
  },
];

/** Sonde de vie, affichée en développement seulement. */
function EtatApi() {
  const [etat, setEtat] = useState('chargement');

  useEffect(() => {
    let annule = false;
    api
      .get('/health')
      .then((d) => !annule && setEtat(`base « ${d.database.name} »`))
      .catch(() => !annule && setEtat('API injoignable'));
    return () => {
      annule = true;
    };
  }, []);

  return <p className="sonde">Développement · {etat}</p>;
}

export function Landing() {
  const { user } = useAuth();

  return (
    <main className="page accueil">
      <section className="heros">
        <p className="heros__surtitre">Planification de voyage assistée</p>
        <h1 className="heros__titre">Le voyage que vous imaginez, jour après jour.</h1>
        <p className="heros__texte">
          Décrivez votre projet en quelques champs. HolidAI en tire un programme
          réaliste, adapté à ceux qui partent avec vous — puis vous laisse le
          reprendre à votre main.
        </p>

        <div className="heros__actions">
          {user ? (
            <>
              <Link className="bouton bouton--lien" to="/voyages">
                Mes voyages
              </Link>
              <span className="heros__salut">Bonjour {user.firstName}</span>
            </>
          ) : (
            <>
              <Link className="bouton bouton--lien" to="/inscription">
                Créer un compte
              </Link>
              <Link className="bouton bouton--lien bouton--discret" to="/connexion">
                Se connecter
              </Link>
            </>
          )}
        </div>
      </section>

      <ul className="arguments">
        {ARGUMENTS.map((argument) => (
          <li key={argument.titre} className="verre argument">
            <h2>{argument.titre}</h2>
            <p>{argument.texte}</p>
          </li>
        ))}
      </ul>

      {/* La sonde ne sert qu'au diagnostic local : elle n'a rien à faire sur la
          page d'accueil d'un site en production. */}
      {import.meta.env.DEV && <EtatApi />}
    </main>
  );
}
